export default __webpack_public_path__ + "static/media/9.0afc56b6.jpg";